import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-quote-square-open",
  "use": "icon-quote-square-open-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 12\" id=\"icon-quote-square-open\">\r\n<path id=\"icon-quote-square-open__x201C_-copy\" d=\"M0,12V5.6L2.7,0h3.3L4.6,5.3H7V12H0z M9,12V5.6L11.7,0h3.3l-1.3,5.3H16V12H9z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/quote-square-open.svg
// module id = 306
// module chunks = 0 1